import { COLOR } from 'admin/constants/styles';
import styled, { css } from 'styled-components';

const base = css`
  display: inline-block;
  color: ${COLOR.gray};
  font-weight: 600;
`;

const H1 = styled.h1`
  ${base}
`;

const H2 = styled.h2`
  ${base}
`;

const H3 = styled.h3`
  ${base}
`;

const H4 = styled.h4`
  ${base}
`;

const H5 = styled.h5`
  ${base}
`;

const H6 = styled.h6`
  ${base}
`;

const Headings = {
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
};

export default Headings;
